import React from "react";
import * as CHQ from "chq";

import { Trans } from "app/utils";
import NotificationBody from "./NotificationBody";

type DownloadingVideoStoryNotificationProps = {
  notification: CHQ.NotificationDownloadingVideoStory;
};

const DownloadingVideoStoryNotification: React.FC<DownloadingVideoStoryNotificationProps> = ({
  notification: { entity }
}) => (
  <NotificationBody actor={entity}>
    <Trans>
      The video is currently being processed and will be ready for download soon.
    </Trans>
    <br />
  </NotificationBody>
);

export default DownloadingVideoStoryNotification;
